import PropTypes from 'prop-types';

const SVG = ({
  style = {
    fill: '#000000',
  },
}) => (
  <svg style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.4 60">
    <path d="M56.12 55.86v1.55A4.16 4.16 0 0153.27 60H3.11c-3.33-1.23-4-3.39-1.93-6.53q7.26-10.92 14.57-21.79c.88-1.33 1.7-2.69 2.66-4a8.8 8.8 0 001.65-5.54V10a2.58 2.58 0 01.09-1.15c.16-.33.56-.74.86-.75s.64.43.94.7c.07.06 0 .24 0 .37 0 5 .1 10-.12 15a9.23 9.23 0 01-1.64 4.25c-3.35 5.2-7.17 10.8-10.66 16.06l-1.25 1.91a23 23 0 00-1.74 2.53c-1.21 1.81-2.42 3.61-3.62 5.42a7.45 7.45 0 00-.46.77C1.49 57 2.06 58 4.17 58h46.84c1 0 2.42-.14 2.91-.78.8-1-.26-2.16-.88-3.11-5.69-8.52-11.36-17.05-17.09-25.54a10.25 10.25 0 01-1.89-5.95V5.94c0-1.35.32-2.1 1.91-1.91v-2H20.06V4h7.28v2h-7.28a1.87 1.87 0 01-2-2v-.38c0-3.25.33-3.62 3.6-3.62h13.7c2.05 0 2.7.65 2.7 2.72 0 2.41-.14 2.67-2 3.39 0 5.81-.08 11.62.06 17.43a7.5 7.5 0 001.32 3.69c5.63 8.56 11.36 17.05 17 25.59.69.94 1.14 2.03 1.68 3.04z" />
    <path d="M53.57 60a4.15 4.15 0 002.84-2.58V60z" fill="#fff" />
  </svg>
);

SVG.propTypes = {
  style: PropTypes.object.isRequired,
};

export default SVG;
